// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6a2fccfe","592":"78f2020d","952":"6bbe3c99"}[chunkId] + ".chunk.js";
};